import React from 'react';
import { Link } from 'react-router-dom';

import confirmationCheck from '../../assets/images/confirmation_check.png';
import logo from '../../assets/images/logo_header.svg';
import bcArrow from '../../assets/images/bc_arrow_white.svg';

import './styles.css';


const Component = ({
  backTo,
  backLabel,
  onBackClick,
  confirmationText,
  noBorder,
  header,
  subtext,
  children,
}) => (
  <div>
    <div styleName="blueTop">
      <div styleName="backContainer">
        <Link
          onClick={onBackClick ? () => (onBackClick()) : () => (true)}
          to={backTo}
          styleName="backLabel"
        >
          <img
            styleName="backArrow"
            src={bcArrow}
            alt="Back to"
          />
          { backLabel }
        </Link>
      </div>
      <img
        styleName="confirmationCheck"
        src={confirmationCheck}
        alt="Confirmation"
      />
      <div styleName="confirmationText">
        { confirmationText }
      </div>
    </div>
    <div styleName="confirmationInfo">
      <img
        styleName="logo"
        src={logo}
        alt="My IPO"
      />
      { header &&
        <div styleName="header">
          { header }
        </div>
      }
      { subtext &&
        <div styleName="subheader">
          { subtext }
        </div>
      }
      <div styleName={noBorder ? 'noBorderContent' : 'pageContent'} >
        { children }
      </div>
    </div>
  </div>
);

export default Component;



// WEBPACK FOOTER //
// ./src/components/BaseConfirmationScreen/index.js